import useFormatter from "@/hooks/use-formatter.hook.ts";
import { useOpenEsignRequest } from "@/pages/esign/use-open-esign-request.hook.ts";
import { PreboardingTaskRow } from "@/pages/preboarding/components/PreboardingTaskRow.tsx";
import { ApiEsignRequest, EsignSignatureType } from "@/types/esign.types.ts";
import { Button, DotSeparator, FontAwesomeIcon, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface PreboardingEsignRowProps {
  esignRequest: ApiEsignRequest;
}

export function PreboardingEsignRow({ esignRequest }: PreboardingEsignRowProps) {
  const { t } = useTranslation();
  const { renderDate } = useFormatter();
  const openEsignRequest = useOpenEsignRequest();

  const isAcknowledge = esignRequest.signature_type === EsignSignatureType.acknowledge;

  return (
    <PreboardingTaskRow
      icon={
        <FontAwesomeIcon
          icon={isAcknowledge ? "fa-light fa-file-check" : "fa-light fa-file-signature"}
          className={"text-[22px]"}
        />
      }
      title={
        isAcknowledge
          ? t("core:esign_request_awaiting_acknowledgment")
          : t("core:esign_request_awaiting_signature")
      }
      caption={
        <DotSeparator>
          <Text className={"text-secondary"}>{esignRequest.document_title}</Text>
          {esignRequest.date_due && (
            <Text className={"text-secondary"}>{renderDate(esignRequest.date_due)}</Text>
          )}
        </DotSeparator>
      }
      action={
        <Button
          variant={"plain"}
          rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
          onClick={() => openEsignRequest(esignRequest)}
        >
          {isAcknowledge ? t("core:esign_read_and_agree") : t("core:esign_sign")}
        </Button>
      }
    />
  );
}
